import { Component, OnInit } from '@angular/core';

@Component ({
  selector: 'app-flight-list-component',
  templateUrl: './flight-list-component.component.html',
  styleUrls: ['./flight-list-component.component.scss']
})
export class FlightListComponentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
